import React, { useState } from "react";
import { BACKEND_URL } from "./config";
import { compareStaff, compareStaffByPrenom } from "../lib/staffSort";

// URL complète d'une photo
export const getPhotoUrl = (photoUrl) => {
  if (!photoUrl) return null;
  if (photoUrl.startsWith('/api')) {
    return `${BACKEND_URL}${photoUrl}`;
  }
  return photoUrl;
};

// Trier les employés par rôle puis par NOM de famille (tri unifié via lib/staffSort)
export const sortEmployeesByRoleThenName = (employees) => {
  return [...(employees || [])].sort(compareStaff);
};

// Trier les employés par rôle puis par PRÉNOM (utilisé dans la vue Planning)
export const sortEmployeesByRoleThenPrenom = (employees) => {
  return [...(employees || [])].sort(compareStaffByPrenom);
};

// Filtrer les employés par recherche de nom/prénom
export const filterEmployeesBySearch = (employees, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') return employees;
  const term = searchTerm.toLowerCase().trim();
  return employees.filter(emp => 
    (emp.prenom && emp.prenom.toLowerCase().includes(term)) ||
    (emp.nom && emp.nom.toLowerCase().includes(term)) ||
    (`${emp.prenom} ${emp.nom}`.toLowerCase().includes(term))
  );
};

// Image avec fallback automatique vers initiales
export const PhotoWithFallback = ({ src, prenom, nom, role, className, fallbackClassName, style }) => {
  const [hasError, setHasError] = useState(false);
  const initials = `${prenom?.[0] || ''}${nom?.[0] || ''}`.toUpperCase();
  const roleClass = role === 'Médecin' ? 'medecin' : role === 'Assistant' ? 'assistant' : '';
  
  if (!src || hasError) {
    return (
      <div className={fallbackClassName || `photo-fallback ${roleClass}`} style={style}>
        {initials}
      </div>
    );
  }
  
  return (
    <img 
      src={getPhotoUrl(src)}
      alt={`${prenom} ${nom}`}
      className={className}
      style={style}
      onError={() => setHasError(true)}
    />
  );
};
